export default {
  title: 'Administração',
  nav: {
    dashboard: 'Operação',
    orders: 'Pedidos',
    customers: 'Clientes',
    leads: 'Atendimento',
    blocklist: 'Blocklist',
    payments: 'Pagamentos',
    subscriptions: 'Assinaturas',
    shipments: 'Fretes',
    suppliers: 'Fornecedores',
    products: 'Produtos',
    devices: 'Tags',
    telemetry: 'Volumetria',
    integrations: 'Integrações',
    audit: 'Auditoria',
    terms: 'Termos',
    sellers: 'Vendedores',
    commissions: 'Comissões',
    impersonate: 'Entrar como cliente',
    groups: {
      sales: 'Comercial',
      finance: 'Financeiro',
      logistics: 'Logística',
      catalog: 'Catálogo',
      system: 'Sistema',
    },
  },
  login: {
    title_a: 'Bem-vindo',
    title_b: 'de volta.',
    subtitle: 'Entre para continuar de olho no que é seu.',
    forgot: 'Esqueci minha senha',
    tfa_note: 'Segundo fator exigido para contas administrativas.',
    test_accounts: 'contas de teste',
    demo_owner: 'Ana, dona de conta',
    demo_basic: 'Beto, básico',
  },
  dashboard: {
    denied: 'Acesso restrito a Super Admin.',
    failed: 'Não foi possível carregar o painel. Verifique a sessão e tente novamente.',
    group: {
      accounts: 'Clientes',
      orders: 'Pedidos',
      shipments: 'Remessas',
      devices: 'Tags',
    },
    metric: {
      accounts_total: 'Clientes (total)',
      accounts_active: 'Clientes ativas',
      orders_paid_not_picked: 'Pedidos pagos não separados',
      orders_in_fulfillment: 'Em separação',
      shipments_awaiting_posting: 'Aguardando postagem',
      shipments_in_transit: 'Em trânsito',
      shipments_exception: 'Exceção de entrega',
      shipments_delivered_not_activated: 'Entregues sem ativação',
      devices_available: 'Tags em estoque',
      devices_activated: 'Tags ativadas',
    },
  },
  telemetry: {
    title: 'Volumetria de telemetria',
    rows_estimate: 'linhas estimadas',
    avg_daily: 'Ingestão média (7d)',
    per_day: 'posições/dia',
    eta_10m: 'Até 10 milhões',
    eta_50m: 'Até 50 milhões',
    eta_hint: 'Gatilho para particionar — SPEC-ESCALA-TELEMETRIA.',
    days: 'dias',
    retention_days: '{days}d',
    no_prune_runs: 'Nenhuma execução do prune nos últimos 30 dias.',
    table: {
      sightings: 'Posições',
      device_events: 'Eventos do coletor',
      geofence_events: 'Eventos de cerca',
      latest_device_locations: 'Últimas posições',
    },
    chart: {
      ingest: 'Posições ingeridas por dia (30d)',
      top_accounts: 'Top contas por posições (30d)',
      prune: 'Linhas apagadas pelo prune',
      retention: 'Contas por retenção contratada',
      sightings_deleted: 'Posições',
      events_deleted: 'Eventos',
      accounts: 'Contas',
    },
  },
  audit: {
    title: 'Auditoria',
    search_aria: 'Buscar na auditoria',
    search_ph: 'Usuário, e-mail ou conta...',
    action_aria: 'Filtrar por ação',
    from: 'De',
    to: 'Até',
    load_failed: 'Não foi possível carregar a auditoria.',
    col_when: 'Quando',
    col_action: 'Ação',
    col_actor: 'Ator',
    col_target: 'Alvo',
    col_account: 'Conta',
    col_ip: 'IP',
    col_origin: 'Origem',
    hide_context: 'Ocultar contexto',
    show_context: 'Ver contexto',
    empty: 'Nenhum evento registrado.',
    events_count: '{count} eventos',
    filter: {
      all: 'Todas as ações',
      auth: 'Autenticação',
      impersonation: 'Impersonação',
      customer: 'Clientes',
      account: 'Contas',
      membership: 'Membros',
      order: 'Pedidos',
      payment: 'Pagamentos',
      shipment: 'Fretes',
    },
    action: {
      customer_registered: 'Cliente cadastrado',
      auth_login: 'Login',
      auth_login_failed: 'Login falhou',
      impersonation_started: 'Impersonação iniciada',
      impersonation_ended: 'Impersonação encerrada',
      customer_updated: 'Cliente editado',
      account_created: 'Tenant criado',
      account_frozen: 'Conta congelada',
      account_unfrozen: 'Conta descongelada',
      membership_invited: 'Convite enviado',
      membership_joined: 'Entrou na conta',
      membership_role_changed: 'Papel alterado',
      membership_removed: 'Membro removido',
      order_created: 'Pedido criado',
      order_transitioned: 'Pedido alterado',
      payment_state_changed: 'Pagamento atualizado',
      payment_synced: 'Pagamento sincronizado',
      shipment_created: 'Remessa criada',
      shipment_event: 'Evento de frete',
    },
  },
  leads: {
    title: 'Atendimento',
    search_ph: 'Buscar por nome, e-mail ou mensagem...',
    load_failed: 'Não foi possível carregar os leads.',
    move_failed: 'Não foi possível mover o lead.',
    empty: 'Nenhum lead registrado ainda.',
    col_new: 'Novos',
    col_contacted: 'Em contato',
    col_converted: 'Convertidos',
    col_lost: 'Perdidos',
    col_blocked: 'Bloqueados',
    col_empty: 'Arraste cards para cá',
    no_name: 'Sem nome',
    field_phone: 'Telefone',
    field_product: 'Produto',
    field_source: 'Origem',
    field_note: 'Mensagem',
    internal_notes: 'Observações internas',
    internal_notes_ph: 'Anotações da equipe — não visíveis ao cliente...',
    notes_saved: 'Observações salvas.',
    notes_failed: 'Não foi possível salvar as observações.',
    has_notes: 'Tem observações internas',
    block: 'Bloquear contato',
    block_hint: 'Bloqueia o e-mail e o telefone deste lead para novas mensagens e cadastros.',
    blocked: 'Contato adicionado à blocklist.',
    block_failed: 'Não foi possível bloquear o contato.',
    move_to: 'Mover para',
    interest: {
      commercial_proposal: 'Comercial',
      support: 'Suporte',
      general: 'Geral',
    },
  },
  customer_edit: {
    title: 'Editar cliente',
    section_data: 'Dados pessoais',
    section_address: 'Endereço',
    section_access: 'Acesso',
    cep: 'CEP',
    cep_loading: 'Buscando endereço...',
    street: 'Logradouro',
    number: 'Número',
    complement: 'Complemento',
    district: 'Bairro',
    city: 'Cidade',
    state: 'UF',
    saved: 'Cliente atualizado.',
  },
  blocklist: {
    title: 'Blocklist',
    intro: 'Entradas bloqueadas não conseguem enviar mensagens pelo site nem criar contas. O visitante recebe uma mensagem genérica.',
    add: 'Bloquear',
    added: 'Entrada adicionada à blocklist.',
    add_failed: 'Não foi possível adicionar à blocklist.',
    removed: '{value} removido da blocklist.',
    remove_failed: 'Não foi possível remover da blocklist.',
    load_failed: 'Não foi possível carregar a blocklist.',
    empty: 'Blocklist vazia.',
    col_type: 'Tipo',
    col_value: 'Valor',
    col_reason: 'Motivo',
    col_by: 'Por',
    col_since: 'Desde',
    type_email: 'E-mail',
    type_phone: 'Telefone',
    type_domain: 'Domínio',
    hint_email: 'usuario{\'@\'}exemplo.com',
    hint_phone: '(11) 99999-0000',
    hint_domain: 'exemplo.com',
    reason_ph: 'Ex.: spam recorrente',
    search_aria: 'Buscar na blocklist',
    search_ph: 'Buscar valor ou motivo...',
    all_types: 'Todos',
    unblock: 'Desbloquear',
    unblock_aria: 'Remover {value} da blocklist',
  },
  customer: {
    back: 'Clientes',
    load_failed: 'Não foi possível carregar o cliente.',
    member_since: 'Cliente desde {date}',
    tags: 'Tags',
    subscriptions: 'Assinaturas',
    orders: 'Pedidos',
    payments: 'Pagamentos',
    no_tags: 'Nenhuma tag nesta conta.',
    no_subs: 'Nenhuma assinatura.',
    no_orders: 'Nenhum pedido.',
    no_payments: 'Nenhum pagamento.',
    no_accounts: 'Este cliente não participa de nenhuma conta.',
    block: 'Bloquear',
    block_hint: 'Impede e-mail e telefone de enviar mensagens e criar contas.',
    blocked: 'Cliente adicionado à blocklist.',
    block_failed: 'Não foi possível bloquear o cliente.',
    until: 'até {date}',
    method: {
      pix: 'PIX',
      boleto: 'Boleto',
      credit_card: 'Cartão',
    },
    // Card "Contratado" + ações de billing (SPEC-BILLING §11/§12)
    contracted: 'Contratado',
    serve_yes: 'Serviço liberado',
    serve_no: 'Serviço bloqueado',
    courtesy_until: 'Cortesia até {date}',
    courtesy_grant: 'Dar dias grátis',
    courtesy_days_prompt: 'Quantos dias de cortesia?',
    courtesy_reason_prompt: 'Motivo (fica na auditoria)',
    courtesy_ok: 'Cortesia aplicada até {date}.',
    courtesy_failed: 'Não foi possível aplicar a cortesia.',
    postpone: 'Postergar vencimento',
    postpone_date_prompt: 'Nova data de vencimento (AAAA-MM-DD)',
    postpone_reason_prompt: 'Motivo (fica na auditoria)',
    postpone_ok: 'Vencimento movido para {date}.',
    postpone_failed: 'Não foi possível postergar o vencimento.',
    billing_state: 'Billing',
    entitlements: 'Direitos vigentes',
    usage_title: 'Uso atual',
    limit_tags: 'Tags',
    limit_mobile: 'Celulares',
    limit_users: 'Usuários',
    limit_geofences: 'Cercas',
    limit_history: 'Histórico',
    history_days: '{n} dias',
    unlimited: 'ilimitado',
    products_bought: 'Produtos comprados',
    no_products: 'Nenhum produto pago.',
    no_entitlements: 'Sem direitos vigentes — nada contratado.',
    order_ref: 'pedido #{id}',
    recurring_tag: 'mensal',
  },
  terms: {
    title: 'Termos legais',
    subtitle: 'Versões dos termos de adesão, privacidade (LGPD) e uso.',
    kinds: {
      adhesion: 'Termo de Adesão',
      privacy_lgpd: 'Política de Privacidade (LGPD)',
      use: 'Termos de Uso',
    },
    current: 'Vigente',
    none_published: 'Nenhuma versão publicada.',
    versions: 'Versões',
    new_version: 'Nova versão',
    edit_draft: 'Editar rascunho',
    view: 'Ver',
    title_field: 'Título do documento',
    body_field: 'Conteúdo (Markdown)',
    save_draft: 'Salvar rascunho',
    create_version: 'Criar versão',
    publish: 'Publicar',
    publish_confirm: 'Publicar a versão {n}? Depois de publicada ela é imutável e passa a valer no checkout e no re-aceite.',
    archive: 'Arquivar',
    archive_confirm: 'Arquivar a versão {n}?',
    saved: 'Rascunho salvo.',
    published_ok: 'Versão {n} publicada — clientes verão o pedido de aceite.',
    archived_ok: 'Versão arquivada.',
    failed: 'Não foi possível salvar.',
    immutable_hint: 'Versão {status} — imutável. Crie uma nova versão para alterar.',
    col_version: 'Versão',
    col_status: 'Status',
    col_published: 'Publicada em',
    acceptances: 'Aceites registrados',
    acceptances_empty: 'Nenhum aceite registrado ainda.',
    col_user: 'Usuário',
    col_order: 'Pedido',
    col_source: 'Origem',
    col_ip: 'IP',
    col_date: 'Data',
    audit_link: 'Auditoria de aceites',
  },
  term_acceptances: {
    title: 'Auditoria de aceites',
    subtitle: 'Registro probatório de quem aceitou cada versão dos termos — origem, IP e user-agent.',
    back_to_terms: 'Voltar aos termos',
    search_aria: 'Buscar usuário',
    search_ph: 'Buscar por nome ou e-mail...',
    kind_aria: 'Filtrar por documento',
    source_aria: 'Filtrar por origem',
    all_kinds: 'Todos os documentos',
    all_sources: 'Todas as origens',
    from: 'De',
    to: 'Até',
    sources: {
      site_checkout: 'Checkout do site',
      panel_buy: 'Compra no painel',
      reaccept_banner: 'Re-aceite no painel',
    },
    col_when: 'Data',
    col_user: 'Usuário',
    col_term: 'Documento',
    col_version: 'v',
    col_order: 'Pedido',
    col_source: 'Origem',
    col_ip: 'IP',
    show_ua: 'Ver user-agent',
    hide_ua: 'Ocultar user-agent',
    empty: 'Nenhum aceite registrado.',
    load_failed: 'Não foi possível carregar os aceites.',
    records_count: '{count} registros',
  },
  customers: {
    title: 'Clientes',
    search_aria: 'Buscar cliente',
    search_ph: 'Buscar por nome, e-mail ou conta...',
    load_failed: 'Não foi possível carregar os clientes.',
    col_customer: 'Cliente',
    col_phone: 'Telefone',
    col_accounts: 'Contas',
    col_status: 'Status',
    col_since: 'Cadastro',
    frozen_tag: '· congelada',
    overdue_tag: '· mensalidade pendente',
    freeze: 'Congelar conta',
    unfreeze: 'Descongelar conta',
    freeze_aria: 'Congelar {name}',
    unfreeze_aria: 'Descongelar {name}',
    frozen_ok: 'Conta "{name}" congelada — localização bloqueada até regularizar.',
    frozen_state: 'Congelada',
    overdue_badge: 'Mensalidade pendente',
    unfrozen_ok: 'Conta "{name}" descongelada.',
    freeze_failed: 'Não foi possível alterar a conta.',
    status_active: 'Ativo',
    status_disabled: 'Desativado',
    empty: 'Nenhum cliente encontrado.',
    empty_hint: 'Ajuste a busca.',
    edit_title: 'Editar cliente',
    disabled_label: 'Usuário desativado',
    disabled_hint: '(não consegue entrar nem ser impersonado)',
  },
  devices: {
    title: 'Tags',
    refresh: 'Atualizar',
    tagit_banner: 'Fonte TagIT não configurada — salve o token em Integrações para escolher as tags aqui. O vínculo manual por texto ainda funciona.',
    search_aria: 'Buscar tag',
    search_ph: 'Nome, serial, public_id ou id do fornecedor...',
    linked_aria: 'Filtrar por vínculo',
    linked_all: 'Todas',
    linked_yes: 'Vinculadas ({count})',
    linked_no: 'Sem vínculo',
    load_failed: 'Não foi possível carregar o inventário.',
    link_failed: 'Falha ao salvar vínculo.',
    col_tag: 'Tag',
    col_model: 'Modelo',
    col_account: 'Conta',
    col_provider_tag: 'Tag no provedor',
    col_state: 'Estado',
    col_last_position: 'Última posição',
    provider_tag_aria: 'Tag do provedor para {name}',
    no_link: '— sem vínculo —',
    out_of_provider: '(fora do provedor)',
    provider_id_ph: 'id_externo / code da tag',
    not_external_hint: 'Vínculo com provedor só se aplica a produtos marcados como "Fornecedor externo".',
    link: 'Vincular',
    unlink: 'Limpar',
    linked_ok: '{name} vinculada.',
    unlinked_ok: '{name} desvinculada.',
    empty: 'Nenhuma tag no inventário.',
    foot_note: 'O vínculo usa {field} — id_externo, code ou id da tag no provedor. Posições do TagIT chegam via {job} e entram no mesmo pipeline de mapa/histórico/cercas do app móvel. Vincule antes de liberar a ativação.',
    activation: {
      not_activated: 'Não ativada',
      provisioning: 'Provisionando',
      active: 'Ativa',
      failed: 'Falhou',
      revoked: 'Revogada',
    },
  },
  impersonate: {
    title: 'Entrar como cliente',
    active_banner: 'Impersonificação ativa — expira {time}',
    stop: 'Encerrar',
    load_failed: 'Não foi possível carregar os clientes.',
    empty: 'Nenhum cliente encontrado.',
    empty_hint: 'Ajuste a busca.',
    accounts_count: '{count} contas',
    context_account: 'Conta de contexto',
    no_specific_account: 'Sem conta específica',
    no_accounts: 'Este usuário ainda não pertence a nenhuma conta.',
    reason_label: 'Motivo (obrigatório)',
    reason_hint: 'Mínimo 10 caracteres — registrado em auditoria.',
    enter_as: 'Entrar como {name}',
    select_title: 'Selecione um cliente',
    select_desc: 'Escolha na lista ao lado a pessoa em nome de quem você vai operar.',
    foot_note: 'Durante a impersonificação ficam bloqueadas mudanças de senha/2FA, identidade Google, propriedade da conta e operações financeiras sensíveis.',
  },
  integrations: {
    title: 'Integrações',
    configured: 'Configurado',
    not_configured: 'Não configurado',
    saved: 'Salvo.',
    save_provider: 'Salvar {name}',
    secret_configured: '• configurado',
    secret_keep: '(deixe vazio para manter)',
    secret_empty: 'não configurado',
    default_empty: 'vazio = padrão',
    keep_option: '— manter ({value}) —',
    keep_default: 'padrão',
    test: 'Testar conexão',
    test_failed: 'Falha no teste',
    testing: 'Testando…',
    track_title: 'Testar rastreio',
    tracking_code: 'Código de rastreio',
    service_code: 'Serviço (opcional)',
    order_number: 'Nº do pedido (opcional)',
    track_run: 'Testar rastreio',
    track_running: 'Rastreando…',
    track_failed: 'Falha no rastreio',
    track_found: 'Rastreio encontrado',
    open_frenet: 'abrir no Frenet',
    track_empty: 'Sem eventos de rastreio retornados.',
    webhooks_title: 'Eventos de webhook',
    filter_all: 'todos',
    filter_pending: 'pendentes',
    filter_processed: 'processados',
    filter_ignored: 'ignorados',
    refresh_events: 'Atualizar eventos',
    attempts: '{count}× tent.',
    with_error: ' · erro',
    external_id: 'ID externo',
    processed_at: 'Processado',
    reprocess: 'Reprocessar',
    reprocessing: 'Reprocessando…',
    reprocess_failed: 'Falha ao reprocessar',
    events_empty: 'Nenhum evento recebido.',
    save_failed: 'Falha ao salvar',
    desc_asaas: 'Cobranças, assinaturas e webhooks de pagamento.',
    desc_frenet: 'Cotação de frete real no checkout.',
    desc_tagit: 'Fonte de telemetria — posições das tags físicas coletadas pelo fabricante.',
    desc_google: 'Login "Continuar com Google" — OAuth Client do projeto no Google Cloud.',
    event_status: {
      processed: 'processado',
      pending: 'pendente',
      ignored: 'ignorado',
    },
  },
  orders: {
    title: 'Pedidos',
    new: 'Novo pedido',
    all_states: 'Todos os estados',
    search_ph: 'Buscar pedido, cliente ou conta…',
    col_order: 'Pedido',
    col_customer: 'Cliente / conta',
    col_state: 'Estado',
    col_tags: 'Tags',
    col_total: 'Total',
    tag_filter_all: 'Tags: todas',
    tag_filter_enabled: 'Habilitadas',
    tag_filter_pending: 'Pendentes de habilitação',
    tag_filter_none: 'Sem tag física',
    tag_count: '{enabled}/{qty} habilitada | {enabled}/{qty} habilitadas',
    ship_filter_all: 'Envio: todos',
    ship_awaiting: 'Aguardando envio',
    ship_posted: 'Enviado',
    ship_none: 'Digital',
    empty: 'Nenhum pedido.',
    created: 'Pedido {id} criado.',
    state: {
      draft: 'Rascunho',
      pending_payment: 'Aguardando pgto',
      paid: 'Pago',
      fulfillment: 'Em separação',
      partially_shipped: 'Parcialmente enviado',
      shipped: 'Enviado',
      delivered: 'Entregue',
      completed: 'Concluído',
      canceled: 'Cancelado',
      refunded: 'Estornado',
    },
    reason: {
      troca_quebrada: 'Troca — tag quebrada',
      perda: 'Troca — tag perdida',
      venda_interna: 'Venda interna (avulsa)',
      outro: 'Outro motivo',
    },
    create: {
      title: 'Novo pedido interno',
      subtitle: 'Troca/perda de tag e venda avulsa — não passa pelo checkout público.',
      customer: 'Cliente',
      account: 'Conta',
      reason: 'Motivo',
      select: 'Selecione…',
      product: 'Produto',
      internal_tag: ' (interno)',
      digital_tag: ' · digital',
      qty: 'Qtd',
      unit_price: 'Preço unit. (R$, opcional)',
      unit_price_ph: 'Tabela',
      add_item: '+ Adicionar item',
      charge_plan: 'Cobrar plano mesmo assim',
      keep_recurring: 'Manter recorrência do produto',
      ship_it: 'Enviar pelos correios',
      no_physical: ' (sem item físico no pedido)',
      shipping_label: 'Frete (R$, vazio = tarifa fixa)',
      shipping_ph: 'Tarifa fixa',
      payment: 'Pagamento',
      pay_pending: 'Pendente — cliente paga depois',
      pay_offline: 'Já pago offline — baixar e provisionar agora',
      note: 'Observação interna (opcional)',
      seller: 'Vendedor',
      seller_none: 'Sem vendedor',
      submit: 'Criar pedido',
      estimate: 'Estimativa',
    },
  },
  order_detail: {
    back: 'Voltar para pedidos',
    title: 'Pedido #{id}',
    print: 'Imprimir',
    created_at: 'Criado {date}',
    paid_at: 'pago {date}',
    timeline: 'Linha do tempo',
    transitions: 'Transição de estado',
    undo_title: 'Desfazer — volta para o estado anterior',
    reason_ph: 'Motivo (opcional)',
    final_state: 'Estado final — sem transições.',
    items: 'Itens',
    monthly_tag: '(mensal)',
    subtotal: 'Subtotal',
    discount: 'Desconto',
    shipping: 'Frete',
    total: 'Total',
    payments: 'Pagamentos',
    due: 'venc. {date}',
    shipments: 'Remessas',
    new_shipment: 'Nova remessa',
    tracking_ph: 'Código de rastreio',
    create_shipment: 'Criar remessa',
    history: 'Histórico',
    transition_failed: 'Falha na transição',
    shipment_failed: 'Falha ao criar remessa',
    seller: 'Vendedor',
    seller_none: 'Sem vendedor',
    seller_saved: 'Vendedor do pedido atualizado.',
    seller_save_failed: 'Falha ao atualizar o vendedor',
  },
  order_print: {
    back: 'Voltar ao pedido',
    print: 'Imprimir',
    receipt: 'Comprovante de pedido — uso interno',
    customer: 'Cliente',
    account: 'Conta: {name}',
    delivery: 'Entrega',
    dates: 'Datas',
    created: 'Criado: {date}',
    paid: 'Pago: {date}',
    items: 'Itens',
    col_item: 'Item',
    col_qty: 'Qtd',
    col_unit: 'Unitário',
    col_total: 'Total',
    monthly_tag: '(mensal)',
    subtotal: 'Subtotal',
    discount: 'Desconto',
    shipping: 'Frete',
    total: 'Total',
    payments: 'Pagamentos',
    shipments: 'Remessas',
    history: 'Histórico',
    footer: 'Impresso em {date} por {name} · Documento gerado pelo painel de administração LOCZI.',
    doc_title: 'Pedido {id} — LOCZI',
  },
  payments: {
    title: 'Pagamentos',
    all_states: 'Todos os estados',
    col_charge: 'Cobrança',
    col_account: 'Conta',
    col_state: 'Estado',
    col_amount: 'Valor',
    col_action: 'Ação',
    monthly_tag: 'mensal',
    sync: 'Sincronizar',
    empty: 'Nenhum pagamento.',
    webhooks_title: 'Webhooks recebidos',
    col_event: 'Evento',
    col_status: 'Status',
    col_attempts: 'Tentativas',
    col_error: 'Erro',
    col_received: 'Recebido',
    events_empty: 'Nenhum evento ainda.',
    state: {
      pending: 'Pendente',
      confirmed: 'Confirmado',
      overdue: 'Vencido',
      refunded: 'Estornado',
      failed: 'Falhou',
      canceled: 'Cancelado',
    },
  },
  subscriptions: {
    title: 'Assinaturas',
    mrr: 'MRR ativo',
    per_month: '/mês',
    active: 'Ativas',
    awaiting_first: 'Aguardando 1º pagamento',
    col_account: 'Conta',
    col_plan: 'Plano',
    col_state: 'Estado',
    col_provider: 'Assinatura no provedor',
    col_cycles: 'Ciclos pagos',
    col_last_cycle: 'Último ciclo',
    col_next: 'Próxima cobrança',
    col_value: 'Valor/mês',
    empty: 'Nenhuma assinatura ainda — nascem do checkout ou de pedido interno recorrente.',
    state: {
      pending: 'Pendente',
      active: 'Ativa',
      overdue: 'Em atraso',
      suspended: 'Suspensa',
      canceled: 'Cancelada',
    },
  },
  shipments: {
    title: 'Fretes e remessas',
    all_states: 'Todos os estados',
    search_ph: 'Código de rastreio…',
    col_shipment: 'Remessa',
    col_order: 'Pedido / conta',
    col_tracking: 'Rastreio',
    col_state: 'Estado',
    col_action: 'Ação',
    volumes: '({count} vol)',
    event: 'Evento',
    empty: 'Nenhuma remessa.',
    event_failed: 'Falha ao registrar evento',
    state: {
      awaiting_posting: 'Aguardando postagem',
      posted: 'Postado',
      in_transit: 'Em trânsito',
      delivered: 'Entregue',
      exception: 'Exceção',
    },
    event_code: {
      posted: 'Postado na transportadora',
      in_transit: 'Em trânsito',
      delivered: 'Entregue',
      exception: 'Exceção/avaria/devolução',
    },
    modal: {
      title: 'Registrar evento',
      desc_ph: 'Descrição do evento',
      tracking_ph: 'Código de rastreio (opcional)',
      submit: 'Salvar evento',
    },
  },
  products: {
    title: 'Produtos',
    new: 'Novo produto',
    search_aria: 'Buscar produto',
    search_ph: 'Buscar por SKU ou nome...',
    load_failed: 'Não foi possível carregar os produtos.',
    col_sku: 'SKU',
    col_product: 'Produto',
    col_model: 'Modelo',
    col_box: 'Caixa (A×L×C)',
    col_max_box: 'Máx/caixa',
    col_status: 'Status',
    tag_recurring: 'assinatura mensal',
    tag_digital: 'digital · sem frete',
    tag_internal: 'só venda interna',
    tag_requires_plan: 'exige {plan}',
    status_coming_soon: 'Em breve',
    status_hidden: 'Oculto',
    status_blocked: 'Venda bloqueada',
    active: 'Ativo',
    inactive: 'Inativo',
    edit: 'Editar',
    empty: 'Nenhum produto cadastrado.',
  },
  product_form: {
    back: 'Voltar para produtos',
    title_new: 'Novo produto',
    title_edit: 'Editar produto',
    not_found: 'Produto não encontrado.',
    identification: 'Identificação',
    sku_hint: 'Imutável após criado — usado no checkout e integrações.',
    name: 'Nome',
    description: 'Descrição',
    device_model: 'Modelo de dispositivo',
    no_model: 'Sem modelo',
    supplier: 'Fornecedor',
    no_supplier: 'Sem fornecedor',
    supplier_hint: 'Vínculo direto — usado nos relatórios. Sem ele, vale o do modelo.',
    required_plan: 'Plano obrigatório',
    no_plan: 'Nenhum (venda avulsa)',
    plan_hint: 'Venda pública exige o plano junto — troca/perda interna dispensa.',
    plan_price: '{name} · R$ {price}/mês',
    rules: 'Regras comerciais',
    status: 'Visibilidade e venda',
    status_public: 'Publicado — no site, com preço',
    status_public_hint: 'Aparece no catálogo do site e vende normalmente.',
    status_coming_soon: 'Em breve — no site, sem preço',
    status_coming_soon_hint: 'Aparece no site com selo "Em breve", sem valores e sem botão de compra.',
    status_hidden: 'Oculto — fora do site, vendável',
    status_hidden_hint: 'Não aparece no catálogo, mas vende por link direto do checkout (homologação).',
    status_blocked: 'Bloqueado — fora do site e sem venda',
    status_blocked_hint: 'Não aparece no site e nenhum canal vende — nem pedido interno.',
    physical: 'Produto físico',
    physical_hint: 'Cobra frete e exige endereço no checkout. Desmarque para serviço digital (ex.: Mobile).',
    recurring: 'Assinatura recorrente',
    recurring_hint: 'Cobra mensalidade do item além do valor inicial.',
    internal: 'Venda interna',
    internal_hint: 'Só aparece no "Novo pedido" do admin — troca/perda nunca vai pro site.',
    provider_external: 'Fornecedor externo',
    provider_external_hint: 'Hardware de terceiro (ex.: TagIT) — cada device do modelo precisa ser vinculado à tag do provedor na tela Tags.',
    active: 'Produto ativo',
    active_hint: 'Inativo sai do catálogo público e do checkout.',
    retention: 'Retenção de histórico (dias)',
    retention_hint: 'Vale para produtos de serviço (ex.: Mobile) — vazio herda a retenção do plano.',
    box: 'Caixa de envio',
    box_hint: 'Dimensões e capacidade alimentam a cotação de frete (Frenet/tarifa fixa).',
    height: 'Altura (cm)',
    width: 'Largura (cm)',
    length: 'Comprimento (cm)',
    weight: 'Peso (kg)',
    max_per_box: 'Máx. por caixa',
    max_per_box_hint: 'Quantos itens cabem numa caixa — a API calcula os volumes.',
    create: 'Criar produto',
    save: 'Salvar alterações',
  },
  suppliers: {
    title: 'Fornecedores',
    new: 'Novo fornecedor',
    search_aria: 'Buscar fornecedor',
    search_ph: 'Buscar por nome ou país...',
    load_failed: 'Não foi possível carregar os fornecedores.',
    col_supplier: 'Fornecedor',
    col_country: 'País',
    col_contact: 'Contato',
    col_models: 'Modelos',
    col_status: 'Status',
    col_since: 'Cadastro',
    active: 'Ativo',
    inactive: 'Inativo',
    edit: 'Editar',
    empty: 'Nenhum fornecedor cadastrado.',
    created: 'Fornecedor "{name}" criado.',
    modal_new: 'Novo fornecedor',
    modal_edit: 'Editar fornecedor',
    name: 'Nome',
    country: 'País',
    country_ph: 'CN, BR, US...',
    email: 'E-mail',
    phone: 'Telefone',
    document: 'Documento',
    document_ph: 'CNPJ, empresa no exterior...',
    active_label: 'Fornecedor ativo',
  },
  sellers: {
    title: 'Vendedores',
    new: 'Novo vendedor',
    search_ph: 'Nome, e-mail ou código…',
    search_aria: 'Buscar vendedor',
    load_failed: 'Não foi possível carregar os vendedores.',
    empty: 'Nenhum vendedor cadastrado.',
    created: 'Vendedor "{name}" criado — código {code}.',
    updated: 'Vendedor atualizado.',
    modal_new: 'Novo vendedor',
    modal_edit: 'Editar vendedor',
    invite_note: 'O vendedor recebe um e-mail para definir a senha de acesso ao portal.',
    col_seller: 'Vendedor',
    col_code: 'Código',
    col_contact: 'Contato',
    col_commission: 'Comissão',
    col_clients: 'Clientes',
    col_accrued: 'A receber',
    col_paid: 'Pago',
    col_status: 'Status',
    col_since: 'Cadastro',
    name: 'Nome',
    email: 'E-mail',
    phone: 'Telefone',
    address: 'Endereço',
    address_ph: 'Rua, número, bairro, cidade/UF…',
    sale_pct: '% comissão de venda',
    recurring_pct: '% comissão recorrente',
    cycle_limit: 'Parcelas com comissão',
    cycle_limit_hint: 'Comissão recorrente pelas primeiras N mensalidades pagas.',
    active_label: 'Vendedor ativo',
    active: 'Ativo',
    inactive: 'Inativo',
  },
  seller_detail: {
    back: 'Voltar aos vendedores',
    load_failed: 'Não foi possível carregar o vendedor.',
    profile: 'Perfil',
    code: 'Código do vendedor',
    referral_link: 'Link de indicação',
    referral_hint: 'Cliente que se cadastra por este link fica vinculado ao vendedor.',
    copy: 'Copiar',
    copied: 'Copiado!',
    portal_access: 'Acesso ao portal',
    no_user: 'Sem usuário vinculado',
    commissions: 'Comissões',
    entries: 'Lançamentos',
    payouts: 'Fechamentos',
    col_period: 'Quinzena',
    col_kind: 'Tipo',
    col_order: 'Pedido',
    col_base: 'Base',
    col_pct: '%',
    col_amount: 'Comissão',
    col_state: 'Status',
    col_paid_at: 'Pago em',
    kind_sale: 'Venda',
    kind_recurring: 'Recorrência #{n}',
    state_accrued: 'A receber',
    state_paid: 'Pago',
    state_canceled: 'Cancelado',
    empty_entries: 'Nenhum lançamento ainda.',
    empty_payouts: 'Nenhum fechamento ainda.',
    pay: 'Pagar quinzena',
    pay_note_ph: 'Referência do pagamento (PIX, comprovante…)',
    pay_confirm: 'Confirmar pagamento de {total} da quinzena {period}?',
    paid: 'Quinzena paga.',
    reopen: 'Reabrir',
    reopen_confirm: 'Reabrir o fechamento de {period}? Os lançamentos voltam a "a receber".',
    reopened: 'Quinzena reaberta.',
    payout_state_paid: 'Pago',
    payout_state_canceled: 'Reaberto',
  },
  commissions: {
    title: 'Comissões',
    subtitle: 'Fechamento quinzenal: dias 1–15 e 16–fim do mês, sobre valores pagos.',
    load_failed: 'Não foi possível carregar as comissões.',
    open_title: 'Quinzenas abertas',
    open_empty: 'Nada a pagar no momento.',
    history_title: 'Fechamentos',
    history_empty: 'Nenhum fechamento ainda.',
    col_seller: 'Vendedor',
    col_period: 'Quinzena',
    col_entries: 'Lançamentos',
    col_total: 'Total',
    col_state: 'Status',
    col_paid_at: 'Pago em',
    col_paid_by: 'Pago por',
    col_note: 'Referência',
    pay: 'Pagar',
    pay_note_ph: 'Referência do pagamento (PIX, comprovante…)',
    paid_flash: 'Quinzena paga.',
    reopen: 'Reabrir',
    reopen_confirm: 'Reabrir o fechamento de {period}? Os lançamentos voltam a "a receber".',
    reopened_flash: 'Quinzena reaberta.',
    state_paid: 'Pago',
    state_canceled: 'Reaberto',
  },
}
